module.exports = __webpack_public_path__ + "static/media/rob_0.72bb6c7d.png";